export const SHOW_SPINNER = "SHOW_SPINNER"
export const HIDE_SPINNER = "HIDE_SPINNER"

export const showSpinner = data => {return {type: SHOW_SPINNER}}
export const hideSpinner = data => {return {type: HIDE_SPINNER}}